import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getRole,
  getParticularPage,
  getNext,
  getPrevious,
  createRole,
  updateRole,
  handleSearch,
  loadOptionsRolePermission,
  getRoleById,
} from "./thunk";

const initialState = {
  roles: [],
  edit: false,
  role: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingRole: false,
  loadingNext: false,
  unAssignedPermissions: [],
  assignedPermissions: [],
  showCreateModal: false,
};

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    roleEditSuccess: (state, action) => {
      state.edit = true;
      state.role = state.roles.find((role) => role.id === action.payload);
    },

    // userGroupEditSuccess: (state, action) => {
    //   state.edit = true;
    //   state.userGroup = state.userGroups.find((userGroup) => userGroup.id === action.payload);
    //   state.permissions = [];
    //   state.loading = false;
    // },
    assignPermissionHandler: (state, action) => {
      state.assignedPermissions = action.payload;
    },
    unAssignedPermissionHandler: (state, action) => {
      state.unAssignedPermissions = action.payload;
    },
    clearAllPermission: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingRole = false;
      state.role = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRoleById.pending, (state) => {
      state.loading = true;
      state.edit = true;
    });
    builder.addCase(getRoleById.fulfilled, (state, action) => {
      state.loading = false;
      state.role = action.payload.data;
    });
    builder.addCase(getRoleById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateRole.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateRole.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateRole.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addCase(loadOptionsRolePermission.pending, (state) => {
      // state.loadingUpdated = true;
      state.unAssignedPermissions = [];
    });
    builder.addCase(loadOptionsRolePermission.fulfilled, (state, action) => {
      // state.loadingUpdated = false;
      state.unAssignedPermissions = action.payload.data;
    });
    builder.addCase(loadOptionsRolePermission.rejected, (state) => {
      // state.loadingUpdated = false;
      state.unAssignedPermissions = [];
    });
    builder.addMatcher(
      isAnyOf(getRole.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingRole = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getRole.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingRole = false;
        state.roles = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getRole.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingRole = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  roleEditSuccess,
  assignPermissionHandler,
  unAssignedPermissionHandler,
  clearAllPermission,
} = roleSlice.actions;

export default roleSlice.reducer;
